import React, { useRef, useCallback } from 'react';
import Icon from '@stone/ui/icon/Icon';
import { useTranslation } from 'react-i18next';
import SearchSuggestions from './SearchSuggestions';
import ModalDrawer from '../modal/ModalDrawer';
import useQueryString from '@common/utils/useQueryString';
import analytics from '@stone/utils/analytics';
const SearchDialog = (props) => {
    const { t } = useTranslation();
    const { suggestions, promoCards } = props.searchData;
    const [inputSearch, setInputSearch] = useQueryString('query');
    const inputRef = useRef(null);
    const inputFirstEdit = useRef(true);
    const searchFormRef = useRef(null);
    const updateInputSearch = (search) => {
        if (inputFirstEdit.current && search.length > 0) {
            analytics.search('search start');
            inputFirstEdit.current = false;
        }
        setInputSearch(search);
    };
    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        window.location.replace(window.location.origin + window.siteUrls.searchresults + `?query=${inputSearch}`);
    }, [inputSearch]);
    const searchField = () => (React.createElement("form", { ref: searchFormRef, className: "search-modal__form", onSubmit: handleSubmit },
        React.createElement("div", { className: "form-group" },
            React.createElement("div", { className: "form-control" },
                React.createElement("label", { className: "font__title", htmlFor: "searchLabel" }, t('search.dialog.inputlabel')),
                React.createElement("input", { ref: inputRef, type: "search", name: "searchLabel", id: "searchLabel", autoComplete: "off", "aria-label": t('search.placeholder'), 
                    // aria-controls={!noResult && inputSearch?.length >= minSearchChars ? 'searchResults' : null}
                    value: inputSearch, onChange: (e) => {
                        updateInputSearch(e.currentTarget.value);
                    } }),
                !!(inputSearch === null || inputSearch === void 0 ? void 0 : inputSearch.length) && inputRef && (React.createElement("button", { type: "button", className: "form-control__reset-button", "aria-label": t('button.resetinput'), onClick: (e) => {
                        e.preventDefault();
                        inputRef.current.value = null;
                        inputRef.current.focus();
                        inputFirstEdit.current = true;
                        updateInputSearch('');
                    } },
                    React.createElement(Icon, { family: "10", name: "close" }))))),
        React.createElement("input", { type: "submit", hidden: true })));
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalDrawer, { isOpen: props.isOpen, className: "search-modal", onRequestClose: () => {
                inputFirstEdit.current = true;
                props.handleClose();
            }, contentLabel: t('label.search'), hideContentLabel: true },
            React.createElement("div", { className: "search-dialog__form" }, searchField()),
            React.createElement(SearchSuggestions, { suggestions: suggestions, promoCards: promoCards }))));
};
export default SearchDialog;
